import React, { useContext, useState } from 'react';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { StaticDatePicker } from '@mui/x-date-pickers/StaticDatePicker';
import dayjs from 'dayjs';
import 'dayjs/locale/br';
import { TextInput } from '../TextInput';
import Icon, { IconType } from '../../icons/Icon';
import { Popover } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { UserContext } from '../../../context/UserContext';

interface DatePickerProps {
  value?: string;
  placeholder?: string;
  onChange: (value?: string) => void;
  mandatory?: boolean;
  label?: string;
  disabled?: boolean;
}

export default function DatePicker({
  value,
  placeholder,
  onChange,
  mandatory = false,
  label,
  disabled,
}: DatePickerProps) {
  const { locale } = useContext(UserContext);

  const date = value ? dayjs(value, 'YYYY-MM-DD') : null;

  const [open, setOpen] = useState<boolean>(false);
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);

  const handleClick = () => {
    const el = document.getElementById('date_picker');
    if (!el) return;
    setAnchorEl(el);
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
    setAnchorEl(null);
  };

  const handleDateChange = (date?: dayjs.Dayjs) => {
    handleClose();
    if (!date) return onChange(undefined);
    const storedDate = date.format('YYYY-MM-DD');
    onChange(storedDate);
  };

  return (
    <>
      <TextInput
        mandatory={mandatory}
        disabled={disabled}
        label={label}
        id={'date_picker'}
        value={(() => {
          if (!value) return '';
          return dayjs(value, 'YYYY-MM-DD').toDate().toLocaleDateString(locale);
        })()}
        placeholder={placeholder}
        onChange={() => {}}
        trailing={
          disabled ? null : (
            <div className='flex hover:cursor-pointer' onClick={handleClick}>
              <Icon type={IconType.calendar} />
            </div>
          )
        }
      />
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        sx={{ marginTop: '38px', marginLeft: '-10px' }}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <StaticDatePicker
            displayStaticWrapperAs='desktop'
            openTo='day'
            minDate={dayjs(0)}
            value={date}
            onChange={(date, context) => {
              if (!date) return;
              handleDateChange(date);
            }}
          />
        </LocalizationProvider>
      </Popover>
    </>
  );
}
